export const SEND_VERIFY_EMAIL_SUCCEEDED = "SEND_VERIFY_EMAIL_SUCCEEDED";
export const SEND_VERIFY_EMAIL_FAILED = "SEND_VERIFY_EMAIL_FAILED";
export const VERIFY_EMAIL_GO_TO_FIRST_STEP = "VERIFY_EMAIL_GO_TO_FIRST_STEP";
export const VALIDATE_TICKET_SUCCEEDED = "VALIDATE_TICKET_SUCCEEDED";
export const VALIDATE_TICKET_FAILED = "VALIDATE_TICKET_FAILED";
export const SET_EMAIL_SUCCEEDED = "SET_EMAIL_SUCCEEDED";
export const SET_EMAIL_FAILED = "SET_EMAIL_FAILED";

export const GO_TO_LINK_USER_TO_VIRTUAL_USER = "GO_TO_LINK_USER_TO_VIRTUAL_USER";
export const LINK_TO_VIRTUAL_USER_SUCCEEDED = "LINK_TO_VIRTUAL_USER_SUCCEEDED";
export const LINK_TO_VIRTUAL_USER_FAILED = "LINK_TO_VIRTUAL_USER_FAILED";
export const UPGRADE_TO_VIRTUAL_USER_SUCCEEDED = "UPGRADE_TO_VIRTUAL_USER_SUCCEEDED";
export const UPGRADE_TO_VIRTUAL_USER_FAILED = "UPGRADE_TO_VIRTUAL_USER_FAILED";

export const LOGIN_BY_EMAIL_SUCCEEDED = "LOGIN_BY_EMAIL_SUCCEEDED";
export const LOGIN_BY_EMAIL_FAILED = "LOGIN_BY_EMAIL_FAILED";
export const COMPLETE_LOGIN_BY_EMAIL_SUCCEEDED = "COMPLETE_LOGIN_BY_EMAIL_SUCCEEDED";
export const COMPLETE_LOGIN_BY_EMAIL_FAILED = "COMPLETE_LOGIN_BY_EMAIL_FAILED";
export const BACK_TO_EMAIL_FORM = "BACK_TO_EMAIL_FORM";
export const START_RESET_PASSWORD_SUCCEEDED = "RESET_PASSWORD_SUCCEEDED";
export const START_RESET_PASSWORD_FAILED = "RESET_PASSWORD_FAILED";
export const RESEND_START_RESET_PASSWORD = "RESEND_START_RESET_PASSWORD";
export const RESEND_START_RESET_PASSWORD_DEBOUNCE_FINISHED = "RESEND_START_RESET_PASSWORD_DEBOUNCE_FINISHED";
export const BACK_TO_PASSWORD_FORM = "BACK_TO_PASSWORD_FORM";
export const BACK_TO_SEND_VERIFY_EMAIL_FORM = "BACK_VERIFY_SEND_VERIFY_EMAIL_FORM";
export const GET_TICKET_EXPIRATION_PERIOD_SUCCEEDED = "GET_TICKET_EXPIRATION_PERIOD_SUCCEEDED";
export const GET_TICKET_EXPIRATION_PERIOD_FAILED = "GET_TICKET_EXPIRATION_PERIOD_FAILED";

export const SET_PASSWORD_SUCCEEDED = "SET_PASSWORD_SUCCEEDED";
export const SET_PASSWORD_FAILED = "SET_PASSWORD_FAILED";
export const RESET_VIRTUAL_USER_PASSWORD_SUCCEEDED= "RESET_VIRTUAL_USER_PASSWORD_SUCCEEDED";
export const RESET_VIRTUAL_USER_PASSWORD_FAILED = "RESET_VIRTUAL_USER_PASSWORD_FAILED";
export const SET_RESET_PASSWORD_STARTED = "SET_RESET_PASSWORD_STARTED";

export const PIN_VALIDATED_SUCCEEDED = "PIN_VALIDATED_SUCCEEDED";
export const PIN_VALIDATED_FAILED = "PIN_VALIDATED_FAILED";

export const GET_AVAILABLE_APPLICATION_SUCCEEDED = "GET_AVAILABLE_APPLICATION_SUCCEEDED";
export const GET_AVAILABLE_APPLICATION_FAILED = "GET_AVAILABLE_APPLICATION_FAILED";

export const GET_SUPERUSER_LINKS_SUCCEEDED = "GET_SUPERUSER_LINKS_SUCCEEDED";
export const GET_SUPERUSER_LINKS_FAILED = "GET_SUPERUSER_LINKS_FAILED";
export const GET_APPLICATION_LINKS_SUCCEEDED = "GET_APPLICATION_LINKS_SUCCEEDED";
export const GET_APPLICATION_LINKS_FAILED = "GET_APPLICATION_LINKS_FAILED";

export const RESET_USER_PASSWORD_SUCCEEDED = "RESET_USER_PASSWORD_SUCCEEDED";
export const RESET_USER_PASSWORD_FAILED = "RESET_USER_PASSWORD_FAILED";
export const ACTIVATE_USER_SUCCEEDED = "ACTIVATE_USER_SUCCEEDED";
export const INACTIVATE_USER_SUCCEEDED = "INACTIVATE_USER_SUCCEEDED";

export const GET_ORGANIZATIONS_BY_VALUE_SUCCEEDED = "GET_ORGANIZATIONS_BY_VALUE_SUCCEEDED";
export const GET_ORGANIZATIONS_BY_VALUE_FAILED = "GET_ORGANIZATIONS_BY_VALUE_FAILED";

export const SELECT_ORGANIZATION = "SELECT_ORGANIZATION";
export const GET_ORGANIZATION_SSO_SETTINGS_BY_SITE_SUCCEEDED = "GET_ORGANIZATION_SSO_SETTINGS_BY_SITE_SUCCEEDED";
export const GET_ORGANIZATION_SSO_SETTINGS_BY_SITE_FAILED = "GET_ORGANIZATION_SSO_SETTINGS_BY_SITE_FAILED";
export const GET_ORGANIZATION_SSO_SETTINGS_BY_ID_SUCCEEDED = "GET_ORGANIZATION_SSO_SETTINGS_BY_ID_SUCCEEDED";
export const GET_ORGANIZATION_SSO_SETTINGS_BY_ID_FAILED = "GET_ORGANIZATION_SSO_SETTINGS_BY_ID_FAILED";

export const GET_USERS_BY_ORG_SUCCEEDED = "GET_USERS_BY_ORG_SUCCEEDED";
export const GET_USERS_BY_ORG_FAILED = "GET_USERS_BY_ORG_FAILED";
export const GET_USER_BY_LOGIN_SUCCEEDED = "GET_USER_BY_LOGIN_SUCCEEDED";
export const GET_USER_BY_LOGIN_FAILED = "GET_USER_BY_LOGIN_FAILED";

export const SELECT_USER = "SELECT_USER";
export const SELECT_PRODUCT = "SELECT_PRODUCT";

export const IMPERSONATION_SUCCEEDED = "IMPERSONATION_SUCCEEDED";
export const IMPERSONATION_FAILED = "IMPERSONATION_FAILED";
export const USER_LOCKED = "USER_LOCKED";

export const USER_UNLOCKED_SUCCEEDED = "USER_UNLOCKED_SUCCEEDED";
export const USER_UNLOCKED_FAILED = "USER_UNLOCKED_FAILED";

export const GET_CURRENT_USER_SUCCEEDED = "GET_CURRENT_USER_SUCCEEDED";
export const GET_CURRENT_USER_FAILED = "GET_CURRENT_USER_FAILED";

export const GET_VIRTUAL_USERS_BY_ORG_SUCCEEDED = "GET_VIRTUAL_USERS_BY_ORG_SUCCEEDED";
export const GET_VIRTUAL_USERS_BY_ORG_FAILED = "GET_VIRTUAL_USERS_BY_ORG_FAILED";

export const LOGIN_TO_SISENSE_SUCCEEDED = "LOGIN_TO_SISENSE_SUCCEEDED";
export const LOGIN_TO_SISENSE_FAILED = "LOGIN_TO_SISENSE_FAILED";

//siteselector page

export const GET_LINKED_USERS_SUCCEEDED = "GET_LINKED_USERS_SUCCEEDED";
export const GET_LINKED_USERS_FAILED = "GET_LINKED_USERS_FAILED";
export const DELETE_USER_LINK_SUCCEEDED = "DELETE_USER_LINK_SUCCEEDED";
export const DELETE_USER_LINK_FAILED = "DELETE_USER_LINK_FAILED";
export const LINK_USER_TO_SITE_SUCCEEDED = "LINK_USER_TO_SITE_SUCCEEDED";
export const LINK_USER_TO_SITE_FAILED = "LINK_USER_TO_SITE_FAILED";

//changePassword

export const GET_USER_BY_ID_SUCCEEDED = "GET_USER_BY_ID_SUCCEEDED";
export const GET_USER_BY_ID_FAILED = "GET_USER_BY_ID_FAILED";

export const CHANGE_USER_PASSWORD_SUCCEEDED = "CHANGE_PASSWORD_SUCCEEDED";
export const CHANGE_USER_PASSWORD_FAILED = "CHANGE_PASSWORD_FAILED";
export const CHANGE_USER_PASSWORD_AND_LOGIN_SUCCEEDED = "CHANGE_USER_PASSWORD_AND_LOGIN_SUCCEEDED";
export const CHANGE_USER_PASSWORD_AND_LOGIN_FAILED = "CHANGE_USER_PASSWORD_AND_LOGIN_FAILED";

export const GET_ORGANIZATION_SETTINGS_BY_ID_SUCCEEDED = "GET_ORGANIZATION_SETTINGS_BY_SITE_SUCCEEDED";
export const GET_ORGANIZATION_SETTINGS_BY_ID_FAILED = "GET_ORGANIZATION_SETTINGS_BY_SITE_FAILED";
export const GET_ORGANIZATION_PASSWORD_SETTINGS_BY_ID_SUCCEEDED = "GET_ORGANIZATION_PASSWORD_SETTINGS_BY_ID_SUCCEEDED";
export const GET_ORGANIZATION_PASSWORD_SETTINGS_BY_ID_FAILED = "GET_ORGANIZATION_PASSWORD_SETTINGS_BY_ID_FAILED";
export const GET_ORGANIZATION_SETTINGS_BY_TICKET_SUCCEEDED ="GET_ORGANIZATION_SETTINGS_BY_TICKET_SUCCEEDED";
export const GET_ORGANIZATION_SETTINGS_BY_TICKET_FAILED = "GET_ORGANIZATION_SETTINGS_BY_TICKET_FAILED";

export const GET_SUPPORTED_BROWSERS_SUCCEEDED = "GET_SUPPORTED_BROWSERS_SUCCEEDED";
export const GET_SUPPORTED_BROWSERS_FAILED = "GET_SUPPORTED_BROWSERS_FAILED";

export const GET_VIRTUAL_PRODUCT_BY_ID_SUCCEEDED = "GET_VIRTUAL_PRODUCT_BY_ID_SUCCEEDED";
export const GET_VIRTUAL_PRODUCT_BY_ID_FAILED = "GET_VIRTUAL_PRODUCT_BY_ID_FAILED";
export const GET_VIRTUAL_PRODUCTS_SUCCEEDED = "GET_VIRTUAL_PRODUCTS_SUCCEEDED";
export const GET_VIRTUAL_PRODUCTS_FAILED = "GET_VIRTUAL_PRODUCTS_FAILED";

export const CLEAR_ERROR_MESSAGE = "CLEAR_ERROR_MESSAGE";

export const LINK_USER_SUCCEEDED = "LINK_USER_SUCCEEDED";
export const LINK_USER_FAILED ="LINK_USER_FAILED";
export const CREATE_USER_SUCCEEDED = "CREATE_USER_SUCCEEDED";
export const CREATE_USER_FAILED = "CREATE_USER_FAILED";
export const UPDATE_USER_SUCCEEDED = "UPDATE_USER_SUCCEEDED";
export const UPDATE_USER_FAILED = "UPDATE_USER_FAILED";

export const GENERATE_PASSWORD_SUCCEEDED = "GENERATE_PASSWORD_SUCCEEDED";
export const GENERATE_PASSWORD_FAILED = "GENERATE_PASSWORD_FAILED";

export const GET_ORGANIZATION_BY_ID_SUCCEEDED= "GET_ORGANIZATION_BY_ID_SUCCEEDED";
export const GET_ORGANIZATION_BY_ID_FAILED = "GET_ORGANIZATION_BY_ID_FAILED";

export const GET_ROLES_BY_PRODUCT_ID_SUCCEEDED = "GET_ROLES_BY_PRODUCT_ID_SUCCEEDED";
export const GET_ROLES_BY_PRODUCT_ID_FAILED = "GET_ROLES_BY_PRODUCT_ID_FAILED";

export const SET_USER = "SET_USER";
export const SET_FIELD = "SET_FIELD";
export const USER_INVALID = "USER_INVALID";
export const USER_SELECT_PRODUCT = "USER_SELECT_PRODUCT";
export const USER_SELECT_ROLE = "USER_SELECT_ROLE";
export const SET_USER_ACTIVE = "SET_USER_ACTIVE";

//login
export const START_LOGIN_SUCCEEDED = "START_LOGIN_SUCCEEDED";
export const START_LOGIN_FAILED = "START_LOGIN_FAILED";
export const START_SSO_LOGIN_SUCCEEDED = "START_SSO_LOGIN_SUCCEEDED";
export const START_SSO_LOGIN_FAILED = "START_SSO_LOGIN_FAILED";
export const RESEND_USER_SETPASSWORD_EMAIL_SUCCEEDED = "RESEND_USER_SETPASSWORD_EMAIL_SUCCEEDED";
export const RESEND_USER_SETPASSWORD_EMAIL_FAILED = "RESEND_USER_SETPASSWORD_EMAIL_FAILED";

// settings page

export const SAVE_SETTINGS_SUCCEEDED = "SAVE_SETTINGS_SUCCEEDED";
export const SAVE_SETTINGS_FAILED = "SAVE_SETTINGS_FAILED";

export const DELETE_ORGANIZATION_LOGO_SUCCEEDED = "DELETE_ORGANIZATION_LOGO_SUCCEEDED";
export const DELETE_ORGANIZATION_LOGO_FAILED = "DELETE_ORGANIZATION_LOGO_FAILED";
export const SAVE_ORGANIZATION_LOGO_SUCCEEDED = "SAVE_ORGANIZATION_LOGO_SUCCEEDED";
export const SAVE_ORGANIZATION_LOGO_FAILED = "SAVE_ORGANIZATION_LOGO_FAILED";
export const GET_ORGANIZATION_LOGO_SUCCEEDED = "GET_ORGANIZATION_LOGO_SUCCEEDED";
export const GET_ORGANIZATION_LOGO_FAILED = "GET_ORGANIZATION_LOGO_FAILED";
export const SET_ORGANIZATION_LOGO = "SET_ORGANIZATION_LOGO";

export const SETTINGS_SET_WEB_TIMEOUT = "SETTINGS_SET_WEB_TIMEOUT";
export const SETTINGS_SET_ACCOUNT_LOCKOUT_INTERVAL = "SETTINGS_SET_ACCOUNT_LOCKOUT_INTERVAL";
export const SETTINGS_SET_ACCOUNT_LOCKOUT_THRESHOLD = "SETTINGS_SET_ACCOUNT_LOCKOUT_THRESHOLD";
export const SETTINGS_SET_PASSWORD_MAXIMUM_AGE = "SETTINGS_SET_PASSWORD_MAXIMUM_AGE";
export const SETTINGS_SET_PASSWORD_MINIMUM_LENGTH ="SETTINGS_SET_PASSWORD_MINIMUM_LENGTH";
export const SETTINGS_SET_ALLOW_PASSWORD_ALPHA_CHAR = "SETTINGS_SET_ALLOW_PASSWORD_ALPHA_CHAR";
export const SETTINGS_SET_PASSWORD_ALPHA_CHAR_NUMBER = "SETTINGS_SET_PASSWORD_ALPHA_CHAR_NUMBER";
export const SETTINGS_SET_PASSWORD_NUM_CHAR_NUMBER = "SETTINGS_SET_PASSWORD_NUM_CHAR_NUMBER";
export const SETTINGS_SET_ALLOW_PASSWORD_UPPERCASE = "SETTINGS_SET_ALLOW_PASSWORD_UPPERCASE";
export const SETTINGS_SET_PASSWORD_UPPERCASE_NUMBER = "SETTINGS_SET_PASSWORD_UPPERCASE_NUMBER";
export const SETTINGS_SET_ALLOW_PASSWORD_LOWERCASE = "SETTINGS_SET_ALLOW_PASSWORD_LOWERCASE";
export const SETTINGS_SET_PASSWORD_LOWERCASE_CHAR_NUMBER = "SETTINGS_SET_PASSWORD_LOWERCASE_CHAR_NUMBER";
export const SETTINGS_SET_ALLOW_PASSWORD_NUMERICS = "SETTINGS_SET_ALLOW_PASSWORD_NUMERICS";
export const SETTINGS_SET_PASSWORD_PUNCT_OTHER_CHAR_NUMBER= "SETTINGS_SET_PASSWORD_PUNCT_OTHER_CHAR_NUMBER";
export const SETTINGS_SET_ALLOW_PASSWORD_PUNCT_OTHER_CHAR = "SETTINGS_SET_ALLOW_PASSWORD_PUNCT_OTHER_CHAR";

//profile page
export const UPDATE_CURRENT_USER_PROFILE_SUCCEEDED = "UPDATE_CURRENT_USER_PROFILE_SUCCEEDED";
export const UPDATE_CURRENT_USER_PROFILE_FAILED = "UPDATE_CURRENT_USER_PROFILE_FAILED";
export const CURRENT_USER_VERIFICATION_EMAIL_RESENT = "CURRENT_USER_VERIFICATION_EMAIL_RESENT";
export const BEGIN_AJAX_CALL = "BEGIN_AJAX_CALL";
export const END_AJAX_CALL = "END_AJAX_CALL";
export const GET_NABP_ROLES_SUCCEEDED = "GET_NABP_ROLES_SUCCEEDED";

// Announcements
export const GET_BANNERS_SUCCEEDED = "GET_BANNERS_SUCCEEDED";
export const GET_BANNERS_FAILED = "GET_BANNERS_FAILED";

